/* eslint-disable prettier/prettier */ /**
 * Do not edit directly
 * Generated on Thu, 14 Dec 2023 14:50:29 GMT
 */
const TitleLargeTitleFontSize = "36px";
const TitleLargeTitleTextDecoration = "none";
const TitleLargeTitleFontFamily = "Poppins";
const TitleLargeTitleFontWeight = 700;
const TitleLargeTitleFontStyle = "normal";
const TitleLargeTitleFontStretch = "normal";
const TitleLargeTitleLetterSpacing = "0px";
const TitleLargeTitleLineHeight = "60px";
const TitleLargeTitleParagraphIndent = 0;
const TitleLargeTitleParagraphSpacing = "8px";
const TitleLargeTitleTextCase = "none";
const TitleStandardTitleFontSize = "26px";
const TitleStandardTitleTextDecoration = "none";
const TitleStandardTitleFontFamily = "Poppins";
const TitleStandardTitleFontWeight = 700;
const TitleStandardTitleFontStyle = "normal";
const TitleStandardTitleFontStretch = "normal";
const TitleStandardTitleLetterSpacing = "0px";
const TitleStandardTitleLineHeight = "40px";
const TitleStandardTitleParagraphIndent = 0;
const TitleStandardTitleParagraphSpacing = "8px";
const TitleStandardTitleTextCase = "none";
const HeadlineRegularFontSize = "20px";
const HeadlineRegularTextDecoration = "none";
const HeadlineRegularFontFamily = "Nunito";
const HeadlineRegularFontWeight = 400;
const HeadlineRegularFontStyle = "normal";
const HeadlineRegularFontStretch = "normal";
const HeadlineRegularLetterSpacing = "0px";
const HeadlineRegularLineHeight = "28px";
const HeadlineRegularParagraphIndent = 0;
const HeadlineRegularParagraphSpacing = "8px";
const HeadlineRegularTextCase = "none";
const HeadlineHeavyFontSize = "20px";
const HeadlineHeavyTextDecoration = "none";
const HeadlineHeavyFontFamily = "Nunito";
const HeadlineHeavyFontWeight = 800;
const HeadlineHeavyFontStyle = "normal";
const HeadlineHeavyFontStretch = "normal";
const HeadlineHeavyLetterSpacing = "0px";
const HeadlineHeavyLineHeight = "28px";
const HeadlineHeavyParagraphIndent = 0;
const HeadlineHeavyParagraphSpacing = "8px";
const HeadlineHeavyTextCase = "none";
const BodyRegularFontSize = "16px";
const BodyRegularTextDecoration = "none";
const BodyRegularFontFamily = "Nunito";
const BodyRegularFontWeight = 400;
const BodyRegularFontStyle = "normal";
const BodyRegularFontStretch = "normal";
const BodyRegularLetterSpacing = "0px";
const BodyRegularLineHeight = "24px";
const BodyRegularParagraphIndent = 0;
const BodyRegularParagraphSpacing = "16px";
const BodyRegularTextCase = "none";
const BodyHeavyFontSize = "16px";
const BodyHeavyTextDecoration = "none";
const BodyHeavyFontFamily = "Nunito";
const BodyHeavyFontWeight = 800;
const BodyHeavyFontStyle = "normal";
const BodyHeavyFontStretch = "normal";
const BodyHeavyLetterSpacing = "0px";
const BodyHeavyLineHeight = "24px";
const BodyHeavyParagraphIndent = 0;
const BodyHeavyParagraphSpacing = "16px";
const BodyHeavyTextCase = "none";
const SmallRegularFontSize = "14px";
const SmallRegularTextDecoration = "none";
const SmallRegularFontFamily = "Nunito";
const SmallRegularFontWeight = 400;
const SmallRegularFontStyle = "normal";
const SmallRegularFontStretch = "normal";
const SmallRegularLetterSpacing = "0px";
const SmallRegularLineHeight = "20px";
const SmallRegularParagraphIndent = 0;
const SmallRegularParagraphSpacing = "8px";
const SmallRegularTextCase = "none";
const SmallHeavyFontSize = "14px";
const SmallHeavyTextDecoration = "none";
const SmallHeavyFontFamily = "Nunito";
const SmallHeavyFontWeight = 800;
const SmallHeavyFontStyle = "normal";
const SmallHeavyFontStretch = "normal";
const SmallHeavyLetterSpacing = "0px";
const SmallHeavyLineHeight = "20px";
const SmallHeavyParagraphIndent = 0;
const SmallHeavyParagraphSpacing = "8px";
const SmallHeavyTextCase = "none";
const XsmallRegularFontSize = "12px";
const XsmallRegularTextDecoration = "none";
const XsmallRegularFontFamily = "Nunito";
const XsmallRegularFontWeight = 400;
const XsmallRegularFontStyle = "normal";
const XsmallRegularFontStretch = "normal";
const XsmallRegularLetterSpacing = "0px";
const XsmallRegularLineHeight = "16px";
const XsmallRegularParagraphIndent = 0;
const XsmallRegularParagraphSpacing = "8px";
const XsmallRegularTextCase = "none";
const XsmallHeavyFontSize = "12px";
const XsmallHeavyTextDecoration = "none";
const XsmallHeavyFontFamily = "Nunito";
const XsmallHeavyFontWeight = 800;
const XsmallHeavyFontStyle = "normal";
const XsmallHeavyFontStretch = "normal";
const XsmallHeavyLetterSpacing = "0px";
const XsmallHeavyLineHeight = "16px";
const XsmallHeavyParagraphIndent = 0;
const XsmallHeavyParagraphSpacing = "8px";
const XsmallHeavyTextCase = "none";
const ButtonButtonMFontSize = "16px";
const ButtonButtonMTextDecoration = "none";
const ButtonButtonMFontFamily = "Nunito";
const ButtonButtonMFontWeight = 700;
const ButtonButtonMFontStyle = "normal";
const ButtonButtonMFontStretch = "normal";
const ButtonButtonMLetterSpacing = "0px";
const ButtonButtonMLineHeight = "21px";
const ButtonButtonMParagraphIndent = 0;
const ButtonButtonMParagraphSpacing = "0px";
const ButtonButtonMTextCase = "none";
const ButtonButtonLFontSize = "18px";
const ButtonButtonLTextDecoration = "none";
const ButtonButtonLFontFamily = "Nunito";
const ButtonButtonLFontWeight = 700;
const ButtonButtonLFontStyle = "normal";
const ButtonButtonLFontStretch = "normal";
const ButtonButtonLLetterSpacing = "0px";
const ButtonButtonLLineHeight = "24px";
const ButtonButtonLParagraphIndent = 0;
const ButtonButtonLParagraphSpacing = "0px";
const ButtonButtonLTextCase = "none";
const ButtonNavigationButtonFontSize = "16px";
const ButtonNavigationButtonTextDecoration = "none";
const ButtonNavigationButtonFontFamily = "Nunito";
const ButtonNavigationButtonFontWeight = 500;
const ButtonNavigationButtonFontStyle = "normal";
const ButtonNavigationButtonFontStretch = "normal";
const ButtonNavigationButtonLetterSpacing = "0px";
const ButtonNavigationButtonLineHeight = "21px";
const ButtonNavigationButtonParagraphIndent = 0;
const ButtonNavigationButtonParagraphSpacing = "0px";
const ButtonNavigationButtonTextCase = "none";

export { BodyHeavyFontFamily, BodyHeavyFontSize, BodyHeavyFontStretch, BodyHeavyFontStyle, BodyHeavyFontWeight, BodyHeavyLetterSpacing, BodyHeavyLineHeight, BodyHeavyParagraphIndent, BodyHeavyParagraphSpacing, BodyHeavyTextCase, BodyHeavyTextDecoration, BodyRegularFontFamily, BodyRegularFontSize, BodyRegularFontStretch, BodyRegularFontStyle, BodyRegularFontWeight, BodyRegularLetterSpacing, BodyRegularLineHeight, BodyRegularParagraphIndent, BodyRegularParagraphSpacing, BodyRegularTextCase, BodyRegularTextDecoration, ButtonButtonLFontFamily, ButtonButtonLFontSize, ButtonButtonLFontStretch, ButtonButtonLFontStyle, ButtonButtonLFontWeight, ButtonButtonLLetterSpacing, ButtonButtonLLineHeight, ButtonButtonLParagraphIndent, ButtonButtonLParagraphSpacing, ButtonButtonLTextCase, ButtonButtonLTextDecoration, ButtonButtonMFontFamily, ButtonButtonMFontSize, ButtonButtonMFontStretch, ButtonButtonMFontStyle, ButtonButtonMFontWeight, ButtonButtonMLetterSpacing, ButtonButtonMLineHeight, ButtonButtonMParagraphIndent, ButtonButtonMParagraphSpacing, ButtonButtonMTextCase, ButtonButtonMTextDecoration, ButtonNavigationButtonFontFamily, ButtonNavigationButtonFontSize, ButtonNavigationButtonFontStretch, ButtonNavigationButtonFontStyle, ButtonNavigationButtonFontWeight, ButtonNavigationButtonLetterSpacing, ButtonNavigationButtonLineHeight, ButtonNavigationButtonParagraphIndent, ButtonNavigationButtonParagraphSpacing, ButtonNavigationButtonTextCase, ButtonNavigationButtonTextDecoration, HeadlineHeavyFontFamily, HeadlineHeavyFontSize, HeadlineHeavyFontStretch, HeadlineHeavyFontStyle, HeadlineHeavyFontWeight, HeadlineHeavyLetterSpacing, HeadlineHeavyLineHeight, HeadlineHeavyParagraphIndent, HeadlineHeavyParagraphSpacing, HeadlineHeavyTextCase, HeadlineHeavyTextDecoration, HeadlineRegularFontFamily, HeadlineRegularFontSize, HeadlineRegularFontStretch, HeadlineRegularFontStyle, HeadlineRegularFontWeight, HeadlineRegularLetterSpacing, HeadlineRegularLineHeight, HeadlineRegularParagraphIndent, HeadlineRegularParagraphSpacing, HeadlineRegularTextCase, HeadlineRegularTextDecoration, SmallHeavyFontFamily, SmallHeavyFontSize, SmallHeavyFontStretch, SmallHeavyFontStyle, SmallHeavyFontWeight, SmallHeavyLetterSpacing, SmallHeavyLineHeight, SmallHeavyParagraphIndent, SmallHeavyParagraphSpacing, SmallHeavyTextCase, SmallHeavyTextDecoration, SmallRegularFontFamily, SmallRegularFontSize, SmallRegularFontStretch, SmallRegularFontStyle, SmallRegularFontWeight, SmallRegularLetterSpacing, SmallRegularLineHeight, SmallRegularParagraphIndent, SmallRegularParagraphSpacing, SmallRegularTextCase, SmallRegularTextDecoration, TitleLargeTitleFontFamily, TitleLargeTitleFontSize, TitleLargeTitleFontStretch, TitleLargeTitleFontStyle, TitleLargeTitleFontWeight, TitleLargeTitleLetterSpacing, TitleLargeTitleLineHeight, TitleLargeTitleParagraphIndent, TitleLargeTitleParagraphSpacing, TitleLargeTitleTextCase, TitleLargeTitleTextDecoration, TitleStandardTitleFontFamily, TitleStandardTitleFontSize, TitleStandardTitleFontStretch, TitleStandardTitleFontStyle, TitleStandardTitleFontWeight, TitleStandardTitleLetterSpacing, TitleStandardTitleLineHeight, TitleStandardTitleParagraphIndent, TitleStandardTitleParagraphSpacing, TitleStandardTitleTextCase, TitleStandardTitleTextDecoration, XsmallHeavyFontFamily, XsmallHeavyFontSize, XsmallHeavyFontStretch, XsmallHeavyFontStyle, XsmallHeavyFontWeight, XsmallHeavyLetterSpacing, XsmallHeavyLineHeight, XsmallHeavyParagraphIndent, XsmallHeavyParagraphSpacing, XsmallHeavyTextCase, XsmallHeavyTextDecoration, XsmallRegularFontFamily, XsmallRegularFontSize, XsmallRegularFontStretch, XsmallRegularFontStyle, XsmallRegularFontWeight, XsmallRegularLetterSpacing, XsmallRegularLineHeight, XsmallRegularParagraphIndent, XsmallRegularParagraphSpacing, XsmallRegularTextCase, XsmallRegularTextDecoration };
